import { Member } from "./Member.ts"
import { VISIBLE_STATE } from "./StateConstants.ts"


export class News {
  objectId
  createdAt
  updatedAt
  title
  newsDate
  source
  sourceLink
  description
  thumbnailImage
  heroImage
  isNew
  hidden
  sortOrder
  mentionedMembers
  hiddenState

  constructor(
    objectId = "",
    createdAt = null,
    updatedAt = null,
    title = "",
    newsDate = null,
    source = "",
    sourceLink = "",
    description = "",
    thumbnailImage = undefined,
    heroImage = undefined,
    isNew = true,
    hidden = true,
    sortOrder = undefined,
    mentionedMembers = undefined,
    hiddenState = undefined
  ) {
    this.objectId = objectId
    this.createdAt = createdAt
    this.updatedAt = updatedAt
    this.title = title
    this.newsDate = newsDate
    this.source = source
    this.sourceLink = sourceLink
    this.description = description
    this.thumbnailImage = thumbnailImage
    this.heroImage = heroImage
    this.isNew = isNew
    this.hidden = hidden
    this.sortOrder = sortOrder
    this.mentionedMembers = mentionedMembers
    this.hiddenState = hiddenState
  }

  static convertFromParseObject(parseObject) {
    const mentionedMembersParse = parseObject?.get("mentionedMembers")
    const mentionedMembers = mentionedMembersParse
      ? mentionedMembersParse.map((member) => Member.convertFromParseObject(member))
      : []
    const hiddenState = parseObject?.get("hidden") ? VISIBLE_STATE.PRIVATE : VISIBLE_STATE.PUBLIC

    return new News(
      parseObject?.id,
      parseObject?.createdAt,
      parseObject?.updatedAt,
      parseObject?.get("title"),
      parseObject?.get("newsDate"),
      parseObject?.get("source"),
      parseObject?.get("sourceLink"),
      parseObject?.get("description"),
      parseObject?.get("thumbnailImage")?.url(),
      parseObject?.get("heroImage")?.url(),
      parseObject?.get("isNew"),
      parseObject?.get("hidden"),
      parseObject?.get("sortOrder"),
      mentionedMembers,
      hiddenState
    )
  }
}
